import api from "./api";

export class UserInfoApiService {

    public skills = []
    public occups = []

    static saveSkills(skills:any,userid:any,cvid:any=null){
        return api.post(`skill/${userid}`,{'skills':skills,'cvid':cvid})
    }

    static getSkills(userid:any){
        return api.get(`skill/${userid}`)
    }

    static EditSkills(id_skill:any){
        const userid = localStorage.getItem('user_id')
        return api.put(`skill`,{'id_skill':id_skill, 'userid': userid})
    }

    static saveJobs(occups:any,userid:any,cvid:any=null){
        return api.post(`occup/${userid}`,{'occups':occups,'cvid':cvid})
    }

    static getJobs(userid:any){
        return api.get(`occup/${userid}`)
    }

    static EditJobs(id_occup:any){
        const userid = localStorage.getItem('user_id')
        return api.put(`occup`,{'id_occup':id_occup, 'userid': userid})
    }

    // Rich experience fields (dates/company/employment type/description) —
    // separate from EditJobs, which only ever updates the standardized title.
    static EditExperienceDetails(id_details:any){
        const userid = localStorage.getItem('user_id')
        return api.put(`occup/details`,{'id_details':id_details, 'userid': userid})
    }

    static DeleteSkill(skillid:any){
        const userid = localStorage.getItem('user_id')
        return api.delete(`skill/${skillid}?userid=${userid}`)
    }
    
    static DeleteOccup(occupid:any){
        const userid = localStorage.getItem('user_id')
        return api.delete(`occup/${occupid}?userid=${userid}`)
    }

    static getUserInfo(userid:any){
        return api.get(`user_info/${userid}`)
    }

    static editUserInfo(body:any){
        return api.put(`edit_user_profile`,body)
    }

    static aiSkills(skill:any){
        return api.post('skill/ai_suggestion',{"skill": skill})
    }

    static aiOccup(occup:any){
        return api.post('occup/ai_suggestion',{"occup": occup})
    }

    static UpdateUserInfo(cv_id:any,body:any){
        return api.put(`user_cv_info/${cv_id}`,body)
    }

    static GetUserCvs(user_id:any){
        return api.get(`user_cvs/${user_id}`)
    }

    static CvGetInfo(user_id:any){
        return api.get(`user_cv_info/${user_id}`)
    }
}